module.exports = __webpack_public_path__ + "img/camp.7e5f7e08.svg";